// KILL OVERLAY
tetloose.siteIsLoadingOverlay = function () {
    $('html *').imagesLoaded()
    .done( function( instance ) {
        $('.u-site-is-loading').fadeOut('slow');
    }).fail( function() {
        $('.u-site-is-loading').fadeOut('slow');
    });
};
